export default __webpack_public_path__ + "static/anti-38ac33ca7f3658f7b062d18d76f54419.png";